<mat-dialog-content>
  <div class="d-flex flex-column align-items-center mb-3 text-center">
    <img
      fetchpriority="high"
      width="72"
      height="72"
      class="mb-4"
      src="images/organization_icon.svg"
      alt="Confirmation"
      title="Confirmation"
    />

    <h6 class="fw-600 mb-3">Create an Organization Account</h6>

    <div class="text-start">
      <ol>
        <li>
          You will need to register yourself using
          <span class="text-primary fw-600">Meri Pehchan</span>
        </li>
        <li>
          Keep any of these documents ready before you start the process:
          <ol type="a">
            <li>Entity Pan Verification</li>
            <li>CIN, DIN Verification</li>
            <li>GST No.</li>
            <li>UDYAM Verification</li>
          </ol>
        </li>
        <li>
          Authorization letter from entity to nominate admin of the portal.
        </li>
      </ol>
    </div>

    <div class="bg-orange-50 w-100 p-2 learn-more">
      <p class="text-sm text-black fw-500 mb-0">
        Don't Know How to Access ?
        <span
          class="text-primary fw-600 cursor-pointer"
          (click)="openLearnMoreDialog()"
          >Learn More.</span
        >
      </p>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="pt-1 pb-4 gap-3">
  <div class="w-100 d-flex justify-content-center">
    <button class="btn btn-bordered flex-grow-1 me-2" mat-dialog-close>
      Cancel
    </button>
    <button class="btn btn-secondary flex-grow-1" [mat-dialog-close]="true">
      Continue
    </button>
  </div>
</mat-dialog-actions>
